import { useState } from 'react';

export default function useOrderedIdsByKey() {
  const [registry, setRegistry] = useState(new Map());

  const getOrderedIds = (key, serverIds) => registry.get(key) ?? serverIds;

  const setOrderedIds = (key, newOrderedIds) => {
    setRegistry((previous) => new Map(previous).set(key, newOrderedIds));
  };

  return [getOrderedIds, setOrderedIds];
}
